/**
 * Tamaño de página de `GET company/b2b/teams/users`: la primera llamada de
 * `useCompanyUsersCatalog` sale como `{ page: 0, size: 20 }`.
 */
export const COMPANY_USERS_CATALOG_PAGE_SIZE = 20;

/** Debounce del input de búsqueda del catálogo de usuarios de la compañía. */
export const COMPANY_USERS_CATALOG_SEARCH_DEBOUNCE_MS = 300;

/**
 * Tamaño de página para barrer `GET company/b2b/teams/users` con `accountId`
 * y armar la lista de usuarios ya asignados. Es distinta de
 * `COMPANY_USERS_CATALOG_PAGE_SIZE`: el catálogo pagina para no traer de más,
 * este barrido pagina para no dejar a nadie afuera — objetivos opuestos.
 */
export const ACCOUNT_ASSIGNED_USERS_PAGE_SIZE = 100;

/**
 * Niveles de usuario que entran en los flujos de asignación de cuentas (ML-168).
 * El admin (4) tiene acceso implícito a todas las cuentas y el externo (5) no se asigna.
 */
export const ACCOUNT_ASSIGNMENT_USER_LEVELS: ReadonlyArray<number> = [1, 2, 3];

/**
 * Tope duro de páginas del barrido de asignados. Con 100 por página cubre
 * 20.000 usuarios de empresa, muy por encima de cualquier cliente real.
 * Existe como corte de último recurso: la única salida del recorrido es que
 * el backend diga `last`, y un `200` fuera de contrato que nunca lo diga
 * dejaría al navegador pidiendo páginas para siempre, sin que el usuario
 * pueda cortarlo.
 */
export const ACCOUNT_ASSIGNED_USERS_MAX_PAGES = 200;
